<template lang="pug">
.preview-iphone-home-bar
  .d-flex.justify-center
    .home-bar
</template>

<script>
export default {
  name: 'PreviewIphoneHomeBar'
}
</script>

<style scoped>
.home-bar {
    width: 45%;
    height: 5px;
    border-radius: 12px;
    background-color: #000000;
}
</style>